var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "is-light section"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [(_vm.attachmentpaths.length) ? _c('table', {
    staticClass: "table table-fixed table-hover table-bordered tableFixHeadBottom table-text-cente"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('tr', [_c('th', [_vm._v("Attachment of Case ID : " + _vm._s(_vm.caseid))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.attachmentpaths), function(path, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('button', {
      staticClass: "btn btn-link px-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.getSignedUrl(path.filename)
        }
      }
    }, [_vm._v(_vm._s(path.filename))])])])
  }))]) : _vm._e()])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "card-header"
  }, [_vm._v("Email Attachment")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-984c4bc6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/emailr/emailattachment.vue
// module id = 924
// module chunks = 1